<template>
	<div class="full-width-carousel">
		<div
			ref="newGlide"
			class="glide"
		>
			<div
				class="glide__track"
				data-glide-el="track"
			>
				<div class="glide__slides">
					<div
						v-for="(image, index) in images"
						:key="index"
						class="glide__slide"
					>
						<img
							:src="image"
							alt="This is us!"
							class="carousel-image"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script setup>
import Glide from "@glidejs/glide";

const newGlide = ref();

const images = [
	"/images/about-page/carousel/image-4.webp",
	"/images/about-page/carousel/image-1.webp",
	"/images/about-page/carousel/image-5.webp",
	"/images/about-page/carousel/image-6.webp",
	"/images/about-page/carousel/image-2.webp",
	"/images/about-page/carousel/image-11.webp",
	"/images/about-page/carousel/image-8.webp",
	"/images/about-page/carousel/image-3.webp",
	"/images/about-page/carousel/image-7.webp",
	"/images/about-page/carousel/image-9.webp",
	"/images/about-page/carousel/image-10.webp",
	"/images/about-page/carousel/image-12.webp",
	"/images/about-page/carousel/image-1.webp",
	"/images/about-page/carousel/image-7.webp",
	"/images/about-page/carousel/image-5.webp",
	"/images/about-page/carousel/image-8.webp",
	"/images/about-page/carousel/image-2.webp",
	"/images/about-page/carousel/image-4.webp",
	"/images/about-page/carousel/image-6.webp",
	"/images/about-page/carousel/image-7.webp",
	"/images/about-page/carousel/image-9.webp",
	"/images/about-page/carousel/image-10.webp",
	"/images/about-page/carousel/image-3.webp",
	"/images/about-page/carousel/image-11.webp",
	"/images/about-page/carousel/image-12.webp"
];

const breakpoints = reactive(
	useBreakpoints({
		small: 768,
		xl: 1280,
		xxl: 2100,
		xxxl: 3200
	})
);

function initGlide() {
	let responsiveElements = {};

	if (breakpoints.isGreater("small")) responsiveElements = {};
	if (breakpoints.isGreater("xl"))
		responsiveElements = { peek: { before: 150, after: 150 } };
	if (breakpoints.isGreater("xxl"))
		responsiveElements = { perView: 5, peek: { before: 320, after: 320 } };
	if (breakpoints.isGreater("xxxl"))
		responsiveElements = { perView: 6, peek: { before: 320, after: 320 } };

	new Glide(newGlide.value, {
		type: "carousel",
		startAt: 0,
		perView: 4,
		gap: 32,
		rewind: true,
		animationDuration: 1600,
		animationTimingFunc: "cubic-bezier(0.165, 0.84, 0.44, 1)",
		autoplay: 2000,
		...responsiveElements,
		breakpoints: {
			768: {
				perView: 3,
				gap: 16
			},
			480: {
				perView: 2,
				gap: 16
			}
		}
	}).mount();
}

onMounted(() => {
	initGlide();
});
</script>
<style scoped lang="scss">
@use "~/assets/utils.scss" as *;

.full-width-carousel {
	position: relative;
	top: 0;
	display: inline-block;
	width: 100vw;
	left: 50%;
	transform: translateX(-50%);
}
.carousel-image {
	width: 220px;
	height: 165px;
	object-fit: cover;
	border-radius: 20px;

	@include breakpoint(md) {
		width: 340px;
		height: 260px;
		max-width: 400px;
		max-height: 310px;
	}
}
</style>
